import { UserLayout, BasicLayout } from '@/components/layouts'
import moduleList from './module'

import Home from '@/views/home'
// import Login from '@/views/user/login'
// import MtLogin from '@/views/user/mtLogin'
import NewLogin from '@/views/user/new-login'
import ForgetPassword from '@/views/user/forget-password'
import Exception403 from '@/views/exception/403'
import Exception404 from '@/views/exception/404'
import Exception500 from '@/views/exception/500'

export const asyncRouterMap = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '首页', permission: true },
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: '/home',
        hidden: true,
        component: Home,
        meta: { title: '首页', permission: true, action: [] },
      },

      ...moduleList,
    ]
  },
  {
    path: '*', redirect: '/404', hidden: true, meta: { permission: true },
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  // 沐甜登录/老链接
  // {
  //   path: '/login',
  //   component: UserLayout,
  //   redirect: '/user/login',
  //   hidden: true,
  //   children: [
  //     {
  //       path: '/user/login',
  //       name: 'login',
  //       component: MtLogin
  //     },
  //   ]
  // },
  // // 中农网登录/老链接
  // {
  //   path: '/znwLogin',
  //   component: UserLayout,
  //   redirect: '/znwLogin/znwLogin',
  //   hidden: true,
  //   children: [
  //     {
  //       path: '/znwLogin/znwLogin',
  //       name: 'znwLogin',
  //       component: Login
  //     },
  //   ]
  // },
  // 合并沐甜和年农网登陆  沐甜登录不限显示市场选择 默认市场
  {
    path: '/login',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: '/user/login',
        name: 'login',
        component: NewLogin
      },
    ]
  },
  {
    path: '/forget-password',
    component: UserLayout,
    redirect: '/user/forget-password',
    hidden: true,
    children: [
      {
        path: '/user/forget-password',
        name: 'forget-password',
        component: ForgetPassword
      },
    ]
  },
  {
    path: '/403',
    component: Exception403
  },
  {
    path: '/404',
    component: Exception404,
  },
  {
    path: '/500',
    component: Exception500
  },
]
